import request from '@/utils/request'

// 章节资源关联相关接口

/**
 * 根据章节ID查询关联的资源列表
 * @param {number} chapterId 章节ID
 * @returns {Promise}
 */
export function getResourcesByChapter(chapterId) {
  return request({
    url: `/chapter-resource-relations/byChapter/${chapterId}`,
    method: 'get'
  })
}

/**
 * 根据资源ID查询关联的章节列表
 * @param {number} resourceId 资源ID
 * @returns {Promise}
 */
export function getChaptersByResource(resourceId) {
  return request({
    url: `/chapter-resource-relations/byResource/${resourceId}`,
    method: 'get'
  })
}

/**
 * 为章节关联资源
 * @param {Object} data 关联数据
 * @param {number} data.chapterId 章节ID
 * @param {number} data.resourceId 资源ID
 * @param {number} data.sortOrder 排序
 * @returns {Promise}
 */
export function associateResourceToChapter(data) {
  return request({
    url: '/chapter-resource-relations/associate',
    method: 'post',
    data
  })
}

/**
 * 取消章节与资源的关联
 * @param {number} chapterId 章节ID
 * @param {number} resourceId 资源ID
 * @returns {Promise}
 */
export function disassociateResourceFromChapter(chapterId, resourceId) {
  return request({
    url: '/chapter-resource-relations/disassociate',
    method: 'delete',
    params: { chapterId, resourceId }
  })
}

/**
 * 批量关联资源到章节
 * @param {Object} data 批量关联数据
 * @param {number} data.chapterId 章节ID
 * @param {Array<number>} data.resourceIds 资源ID列表
 * @returns {Promise}
 */
export function batchAssociateResourcesToChapter(data) {
  return request({
    url: '/chapter-resource-relations/batch-associate',
    method: 'post',
    data
  })
}

/**
 * 获取章节关联的完整资源信息
 * @param {number} chapterId 章节ID
 * @returns {Promise}
 */
export function getChapterResourcesWithDetails(chapterId) {
  return request({
    url: `/chapter-resource-relations/resources-with-details/${chapterId}`,
    method: 'get'
  })
}
